export default "__VITE_ASSET__Bv5hnaYU__"